function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "volumeMuteIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.2699999,3 L3,4.2699999 L7.73000004,9 L3,9 L3,15 L7,15 L12,20 L12,13.2700003 L16.2499998,17.5200006 C15.5800002,18.0400008 14.8299996,18.4500012 14,18.7000003 L14,20.7600006 C15.3800004,20.450001 16.6300014,19.8099993 17.689998,18.9500005 L19.7299997,21 L21,19.7299997 L12,10.7299997 L4.2699999,3 L4.2699999,3 Z M18.4599996,14.63998 C18.7999994,13.8199812 19,12.9399813 19,11.9999809 C19,8.82998005 16.8899997,6.14998057 14,5.28998041 L14,3.22998047 C18.0100004,4.13998026 21,7.71998021 21,11.9999809 C21,13.4999807 20.6300017,14.9099809 19.9699994,16.1499805 L18.4599996,14.63998 L18.4599996,14.63998 Z M9.910034,6.09000015 L12.0000342,4 L12.0000342,8.1800003 L9.910034,6.09000015 L9.910034,6.09000015 Z M14,7.9699707 C15.4799995,8.70997101 16.5,10.2299705 16.5,11.9999711 C16.5,12.2199703 16.4799995,12.4299713 16.4500008,12.6299701 L14,10.1799713 L14,7.9699707 L14,7.9699707 Z",
  fill: "#EF4E23"
})));

var SvgVolumeMute = function SvgVolumeMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume-mute.db717597.svg";
export { ForwardRef as ReactComponent };